import { type ReactNode } from 'react'

/** One cell of the KPI stat-strip — the Dashboard analytics idiom (`stat-cell` / big `stat-num` /
 *  mono `stat-label`). Renders a big value (accent by default, or a severity colour) or arbitrary
 *  `children` (e.g. the latest patched version) centred where the number would sit. */
export function StatCell({ label, value, color, children }: {
  label: string
  value?: ReactNode
  color?: string
  children?: ReactNode
}) {
  return (
    <div className="stat-cell">
      {children
        ? <div style={{ minHeight: 28, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{children}</div>
        : <div className="stat-num" style={color ? { color } : undefined}>{value}</div>}
      <div className="stat-label">{label}</div>
    </div>
  )
}
